import { useState, useEffect } from "react";
import { createUseStyles } from "react-jss";

import { cardTypeService } from "services";
import { CardTypeCommon, CardTypeDto, CardTypeRequestDto } from "dtos/shard/card-type.dto";
import { UserDto } from "dtos/user.dto";

import widgets from "styles/widgets";
import { useResources } from "hooks/resources.hook";
import { useEditorActions } from "hooks/editor-actions.hook";
import { useEditorPreview } from "hooks/editor-preview.hook";
import EditorControls from "../editor-controls";

const styles = createUseStyles({
    container: {
        width: "100%",
    },
});

export default function CardTypeEditor(props: {
    user?: UserDto, // Optional dto of the user.
    cardType?: Partial<CardTypeDto>,
    preview?: Partial<CardTypeDto>,
    onPreviewUpdate?: (previewDto: Partial<CardTypeDto>) => void,
    onClose?: () => void,
    onSave?:(cardType: CardTypeDto) => void,
}): JSX.Element
{
    // Dtos:
    const freshCommon: CardTypeCommon = {
        name: props.cardType?.name ?? "",
    };
    const freshRequestDto: CardTypeRequestDto = {
        id: props.cardType?.id,
        ...freshCommon,
        templateId: props.cardType?.template?.id ?? "",
    };
    const freshPreviewDto: Partial<CardTypeDto> = props.preview ? structuredClone(props.preview) : props.cardType ? structuredClone(props.cardType) : {
        id: undefined,
        ...freshCommon,
    };

    // Hooks:
    const resources = useResources(props.user);
    const [previewDto, requestDto, previewUpdate, setRequestDto] = useEditorPreview(freshPreviewDto, freshRequestDto, props.onPreviewUpdate);
    const [onTextChange, onNumberChange, onRteChange, onCheckboxChange, onPopup] = useEditorActions(props.user, "cardType", resources, requestDto, previewDto, setRequestDto, props.onPreviewUpdate);

    // Effects:
    useEffect(() => {
        setRequestDto(freshRequestDto);
    }, [props.cardType]);

    // Styles:
    const widgetClasses = widgets();
    const classes = styles();

    // CardTypes:
    const reset = () => {
        setRequestDto(freshRequestDto);
        if (props.onPreviewUpdate) {
            props.onPreviewUpdate(props.cardType ?? previewDto);
        }
    };
    
    // Return Component:
    return (
        <div className={`${widgetClasses.form} ${classes.container}`}>
            <div className={`${widgetClasses.row}`}>
                <label>Name</label>
                <input id="name" type="text" value={requestDto.name ?? ""} onChange={onTextChange} />
            </div>
            <div className={`${widgetClasses.row} ${widgetClasses.capitalize}`}>
                <button id="template" onClick={() => onPopup("template", "templateId", true)}>Set Type: {previewDto.template?.name ?? "Please Select"}</button>
            </div>

            <hr/>
            <EditorControls
                editorName="cardType"
                service={cardTypeService}
                subject={props.cardType}
                subjectName={props.cardType?.name ?? ""}
                requestDto={requestDto}
                onSave={props.onSave}
                onReset={reset}
                onClose={props.onClose}
            />
            <hr/>
        </div>
    );
}